import { Anchor } from '@mantine/core';
import { useState } from 'react';
import { idCreator } from '../../../../../Project/utils/idCreator';

const DEFAULT_MAX_LENGTH = 120;

export const SeeMoreText = ({ text, maxLength = DEFAULT_MAX_LENGTH }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  if (text.length <= maxLength) {
    return text;
  }

  const displayText = expanded ? text : `${text.slice(0, maxLength)}...`;

  const handleToggle = event => {
    event.preventDefault();
    event.stopPropagation();
    setExpanded(prev => !prev);
  };

  return (
    <>
      {displayText}{' '}
      <Anchor
        id={`formpf-see-more-text-toggle-${idCreator(text)}`}
        component="button"
        type="button"
        size="xs"
        onClick={handleToggle}
      >
        {expanded ? 'Show less' : 'Show more'}
      </Anchor>
    </>
  );
};
